import {creates, elementFactory, hoistCmp} from '@xh/hoist/core';
import Plot from 'react-plotly.js';
import {VolSurfaceWidgetModel} from './VolSurfaceWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import './VolSurfaceWidget.scss';
import {useOnResize} from '@xh/hoist/utils/react';
import {placeholder} from '@xh/hoist/cmp/layout';
import {Icon} from '@xh/hoist/icon';

const plotly = elementFactory(Plot);

export const volSurfaceWidget = hoistCmp.factory({
    model: creates(() => VolSurfaceWidgetModel),
    render({model}) {
        const resizeRf = useOnResize(r => model.resize(r));
        return panel({
            ref: resizeRf,
            item: model.symbol
                ? plotly({
                      className: 'rzx__vol-surface',
                      data: model.data,
                      layout: model.layout,
                      config: model.plotConfig,
                      useResizeHandler: true
                  })
                : placeholder(Icon.gear(), 'Configure')
        });
    }
});
